export default "<p>\n  services-versions works!\n</p>\n"